/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { APIAlert } from '@mummssoftware/common-ui';
import { GlobalContext } from '@mummssoftware/global-context';
import { ListForms } from './ListForms';
import { FajitaIntro } from '../FajitaForms/FajitaIntro';
import { FormsContext } from '../../context';
import { FormScrollWrapper } from '../../components/layout/WrapperDiv';

export const CrossPlatform = () => {
  const { smallWidget, errorInfo, clearError } = useContext(FormsContext);
  const { fajitaFormGlobal } = useContext(GlobalContext);

  const getExpandedUI = () => (
    <FormScrollWrapper>
      {fajitaFormGlobal ? <FajitaIntro /> : <ListForms />}
    </FormScrollWrapper>
  );

  const getUI = () => (smallWidget ? <ListForms /> : getExpandedUI());

  // todo initial error to be on widget
  return (
    <>
      <APIAlert
        errorInfo={errorInfo}
        persistentError
        handleClose={() => clearError()}
      />
      {getUI()}
    </>
  );
};

export default CrossPlatform;
